import { Component } from '@angular/core';

@Component({
  selector: 'page-header-actions',
  templateUrl: './page-header-actions.component.html',
  styleUrls: ['./page-header-actions.component.scss']
})
export class PageHeaderActionsComponent {

}
